import {
  getCountryCodeFromCountry,
  getCountryNameFromCode,
} from "backend/src/common/utils/country-code.util";

import {
  LocationEntityCountry,
  UserUpdateProfileDtoCountry,
} from "../hooks/api/generated";

export interface IParsedLocation {
  countryCode: UserUpdateProfileDtoCountry;
  country: string;
  locality: string;
  fullLocation: string;
}

export const parseLocation = (
  locationValue: string
): IParsedLocation | null => {
  const symbolForParse = locationValue?.includes(",") ? "," : "-";
  if (!symbolForParse) {
    return null;
  }
  const location = locationValue?.split(symbolForParse);
  const country = location?.pop()?.trim() ?? "United Kingdom";

  const countryCode = getCountryCodeFromCountry(
    country
  ) as UserUpdateProfileDtoCountry;

  return {
    countryCode,
    country,
    locality: location.toString(),
    fullLocation: locationValue,
  };
};

export const stringifyLocation = (
  location?: string,
  countryCode?: LocationEntityCountry
): string => {
  if (!location) {
    return "";
  }
  if (!countryCode) {
    return location;
  }
  const countryName = getCountryNameFromCode(countryCode);

  if (countryName && location.includes(countryName)) {
    return location;
  }
  return `${location}, ${countryName || "United Kingdom"}`;
};
